<template>
  <v-select
    :label="$t('Delivery.Fields.origin_flg')"
    v-model="model"
    :items="origin_flgs"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
  ></v-select>
</template>

<script>
import consts from "@/consts.js";

export default {
  name: "SearcherPurchaseOriginFlgs",

  props: ["value"],

  computed: {
    origin_flgs() {
      return consts.origin_flgs.filter(
        (element) =>
          element.value == 101 || element.value == 102
      );
    },
  },

  data: () => ({
    model: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      handler() {
        this.$emit("input", this.model);
      },
    },
  },
};
</script>
